// extracted by mini-css-extract-plugin
export default {"root":"VLModalTitle_root__1sNIf","subtitle":"VLModalTitle_subtitle__5jCJj"};